import type { GetAccountSettingsRequest } from '@patrianna/shared-patrianna-types/websocket/requests'
import type { GetAccountSettingsResponse } from '@patrianna/shared-patrianna-types/websocket/response'
import { setRedeemPolicy } from '@patrianna-payments/shared-store/redeem'

import type { TypedThunk } from 'src/store/types'
import { savePasswordPolicy, saveUseImageBasedCaptcha } from 'store/modules/appConfig/actions'

const getAccountSettingsRequest =
  (): TypedThunk =>
  (dispatch, _, { api, errorHandler }) => {
    const data: GetAccountSettingsRequest = {
      type: 'GetAccountSettingsRequest',
    }

    api
      .getAccountSettings({})
      .then((body: GetAccountSettingsResponse) => {
        dispatch(
          setRedeemPolicy({
            policy: {
              sweepstakeRedeemPolicy: body.sweepstakeRedeemPolicy,
              fiatRedeemPolicy: body.fiatRedeemPolicy,
              nonMonetaryRedeemPolicy: body.nonMonetaryRedeemPolicy,
            },
          }),
        )
        dispatch(savePasswordPolicy({ passwordPolicy: body.passwordPolicy }))
        dispatch(saveUseImageBasedCaptcha({ useImageBasedCaptcha: body.useImageBasedCaptcha }))
      })
      .catch((err) => {
        dispatch(errorHandler(err, data))
      })
  }

export default getAccountSettingsRequest
